/**
 *
 * Asynchronously loads the component for CompanyDetailPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CompanyDetailPage = lazyLoad(
  () => import('./index'),
  module => module.default,
);
